export default function RemixIcon(props) {
  const {
    color,
    icon = 'checkbox-blank',
    size = 12,
    filled = false,
    noVariants = false,
  } = props;

  return (
    <i
      className={`ri-${icon}${noVariants ? '' : `-${filled ? 'fill' : 'line'}`}`}
      style={{ fontSize: `${size}px`, color }}
    />
  );
}
